<template>
  <div class="get-ticket-page grid-layout page-wrapper">
    <div class="grid-layout__main">
      <h1>{{ $t('myPage.anonymousTicket.title') }}</h1>
      <div class="grid-layout__main">
        <div class="card get-ticket-page__card">
          <div class="get-ticket-page__form">
            <Input
              :id="'booking-number'"
              :label="$t('myPage.anonymousTicket.bookingNumber')"
              v-model="bookingNumber"
              :disabled="isBookingNumberFromRoute"
              :internal-label="true"
              :placeholder="$t('myPage.anonymousTicket.bookingNumberPlaceholder')"
            />

            <Input
              :id="'email'" 
              :label="$t('myPage.anonymousTicket.email')"
              v-model="email"
              type="email"
              :internal-label="true"
              :placeholder="$t('myPage.anonymousTicket.emailPlaceholder')"
              :autocomplete="'email'"
            />

            <button 
              class="button button--primary button--medium"
              @click="handleSubmit"
              :disabled="!isValid || isLoading"
            >
              {{ $t('myPage.anonymousTicket.continue') }}
            </button>

            <div v-if="error" class="get-ticket-page__error">
              {{ error }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import Input from '@/components/BaseComponents/Input.vue'
import { useAuthStore } from '@/stores/oauthStore'

export default defineComponent({
  name: 'GetTicketPage',
  components: {
    Input
  },
  props: {
    bookingNumber: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const router = useRouter()
    const authStore = useAuthStore()
    const { t } = useI18n()

    const bookingNumber = ref(props.bookingNumber)
    const email = ref('')
    const error = ref('')
    const isLoading = ref(false)

    const isBookingNumberFromRoute = computed(() => !!props.bookingNumber)

    const isValid = computed(() => {
      return bookingNumber.value && email.value && email.value.includes('@')
    })

    const handleSubmit = async () => {
      if (!isValid.value) return

      isLoading.value = true
      error.value = ''

      try {
        await authStore.getBookingToken(bookingNumber.value, email.value)
        
        // Navigate to ticket page (token is now in authStore)
        router.push({
          name: 'ticketPage',
          params: { bookingNumber: bookingNumber.value }
        })
      } catch (err) {
        error.value = t('errors.invalidBookingDetails')
      } finally {
        isLoading.value = false
      }
    }

    return {
      bookingNumber,
      email,
      error,
      isLoading,
      isValid,
      isBookingNumberFromRoute,
      handleSubmit
    }
  }
})
</script>

<style lang="scss" scoped>
.get-ticket-page {
  padding: 2rem 0;

  &__card {
    padding: 2rem;
  }

  &__form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  &__error {
    color: var(--color-error);
  }
}
</style>
